import Selectize from '@selectize/selectize'
window.Selectize = Selectize
